import { render, staticRenderFns } from "./MarkdownRender.vue?vue&type=template&id=1d224ea0&scoped=true&"
import script from "./MarkdownRender.vue?vue&type=script&lang=js&"
export * from "./MarkdownRender.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownRender.vue?vue&type=style&index=0&id=1d224ea0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d224ea0",
  null
  
)

export default component.exports